// extracted by mini-css-extract-plugin
export var item = "history-item-module--item--khXbI";
export var outputs = "history-item-module--outputs--Huc-G";
export var outputsItem = "history-item-module--outputs-item--hK2dn";
export var outputsItemTitle = "history-item-module--outputs-item-title--gin28";
export var outputsItemDescription = "history-item-module--outputs-item-description--b-BQh";
export var title = "history-item-module--title--eZnZ0";
export var description = "history-item-module--description--qQit0";
export var wrapper = "history-item-module--wrapper--JJPlc";